var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MenuList',{attrs:{"menuList":_vm.menuList},on:{"handleClicks":function (key) { return _vm.excludeShapesBys(key); }}})}
var staticRenderFns = []

export { render, staticRenderFns }